import { Stack } from '@yandex-int/k-common/typings';
// @ts-ignore
import { InjectedProps as WithRouterPathProps } from 'platform-components/src/utils/hocs/with-router-path/with-router-path';
import { InjectedProps as WithProblemBlockPlateHOC } from 'platform-components/src/utils/hocs/withProblemBlockPlate';
import { withProblemBlockPlate, withRouterPath } from 'platform-components/hocs';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { actions as lessonActions } from 'common.components/lesson';
import * as lessonSelectors from 'common.components/lesson/selectors';
import { teamBuilderActions } from 'common.components/team-builder/actions';
import * as userActions from 'common.components/user/actions';
import * as userSelectors from 'common.components/user/selectors';

import { ReduxTeacherStore, RootAction } from '../../../typings';
import { actions as lessonWidgetActions } from '../../lesson-editor-widget/actions';
import * as actions from '../../library.store/actions';
import * as selectors from '../../library.store/selectors';

import { ThemePageStackMemo } from './theme-page__stack';

interface OwnProps extends WithRouterPathProps, WrappedComponentProps {
    onProblemRef: (ref: HTMLDivElement) => void;
    shouldShowTag?: boolean;
    stack: Stack;
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps) => {
    return {
        canEditLesson: lessonSelectors.getCanEditLesson(storeState),
        isLoading: selectors.getIsProblemLoading(storeState, ownProps.stack.representative),
        currentStackProblemsCountInCurrentLesson: selectors.getProblemCountInCurrentLesson(storeState, ownProps),
        problemsInLessonCount: lessonSelectors.getLoadedLessonProblems(storeState).length,
        hasNoTeams: userSelectors.getHasNoActiveTeams(storeState),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => {
    return bindActionCreators(
        {
            addProblemToLesson: actions.addProblemToLesson,
            removeAllStackProblemsFromLesson: lessonActions.removeAllStackProblemsFromLesson,
            deleteLesson: lessonActions.deleteCLesson,
            selectStack: actions.selectStack,
            setWizardVariables: userActions.setWizardVariables,
            toggleWidgetTooltip: lessonWidgetActions.toggleLessonWidgetTooltip,
            toggleLessonWidget: lessonWidgetActions.toggleLessonWidget,
            saveOrCreateLesson: lessonActions.saveOrCreateLesson,
            startTeamBuilder: teamBuilderActions.start,
        },
        dispatch
    );
};

type StoreProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;

export interface Props extends StoreProps, WithProblemBlockPlateHOC, OwnProps, DispatchProps {}

export const ThemePageStackContainer = withProblemBlockPlate(
    withRouterPath(injectIntl(connect(mapStateToProps, mapDispatchToProps)(ThemePageStackMemo)))
);

ThemePageStackContainer.displayName = 'ThemePageStack';
